module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.muestraModalExcelSaldo
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalExcelSaldo
    }
  }), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Mes")]), _c('div', {
    staticClass: "d-flex width-100"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "select is-small d-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mesExportar),
      expression: "mesExportar"
    }],
    staticClass: "flex-1",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mesExportar = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.arrayMeses), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.id + ' - ' + item.nombre))])
  }), 0)])])])]), _c('div', {
    staticClass: "column is-6"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Periodo")]), _c('div', {
    staticClass: "d-flex width-100"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "select is-small d-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodoExportar),
      expression: "periodoExportar"
    }],
    staticClass: "flex-1 width-600",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodoExportar = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.arrayYear), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nombre))])
  }), 0)])])])])])])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-outlined info-box-button is-uppercase",
    on: {
      "click": _vm.closeModalExcelSaldo
    }
  }, [_vm._v("Cancelar")]), [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button is-uppercase",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.fetchExportarExcelSaldo()
      }
    }
  }, [_c('span', [_vm._v("Exportar")])])]], 2)])]), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Empleados")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret",
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Codigo de empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtroCodigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Urgencia")])]), _c('div', {
    staticClass: "status-container-filtro"
  }, _vm._l((_vm.filtrosUrgencia), function(o) {
    return _c('div', {
      staticClass: "status",
      class: {
        'selected': o === _vm.filtroUrgencia
      },
      on: {
        "click": function($event) {
          _vm.filtroUrgencia = o
        }
      }
    }, [_c('div', {
      staticClass: "circle",
      class: o
    })])
  }), 0)])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.exportarExcel
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Excel")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.showModalExportarExcelSaldo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Saldo Vacaciones")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha de Ingreso")]), _c('th', [_c('span', [_vm._v("Días por tomar / programar")])]), _c('th', [_vm._v("DNI")]), _c('th', [_vm._v("Jefe")]), _c('th', {
    staticClass: "td-status"
  })]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.listaFiltrada), function(o, index) {
    return _c('tr', {
      key: index + '-desktop',
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))]), _c('span', {
      staticClass: "email"
    }, [_vm._v(" (" + _vm._s(o.cargo) + ")")]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(_vm._s(o.email))])]), _c('td', [_vm._v(_vm._s(o.fechaIngreso))]), _c('td', [_vm._v(_vm._s(o.diasReales) + " / " + _vm._s(o.diasDisponibles))]), _c('td', [_vm._v(_vm._s(o.dni))]), _c('td', [_c('span', {
      staticClass: "name hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_vm._v(_vm._s(o.nombreJefe))]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(_vm._s(o.emailJefe))])]), _c('td', {
      staticClass: "td-status"
    }, [_c('div', {
      staticClass: "status"
    }, [_c('div', {
      staticClass: "circle",
      class: {
        'yellow': o.diasDisponibles >= 35 && o.diasDisponibles <= 40,
          'red': o.diasDisponibles > 40
      }
    })])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.listaFiltrada), function(o, index) {
    return _c('div', {
      key: index + '-mobile',
      staticClass: "box has-text-left"
    }, [_c('div', {
      staticClass: "dias"
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(o.diasReales) + " ")]), _c('span', [_vm._v("por tomar / ")]), _c('strong', [_vm._v(_vm._s(o.diasDisponibles) + " ")]), _c('span', [_vm._v("por programar ")])]), _c('div', {
      staticClass: "status"
    }, [_c('div', {
      staticClass: "circle",
      class: {
        'yellow': o.diasDisponibles >= 35 && o.diasDisponibles <= 40,
          'red': o.diasDisponibles > 40
      }
    })])]), _c('div', {
      staticClass: "mt-10"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Cargo: ")]), _c('span', [_vm._v(_vm._s(o.cargo))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Email: ")]), _c('span', [_vm._v(_vm._s(o.email))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Fecha de Ingreso: ")]), _c('span', [_vm._v(_vm._s(o.fechaIngreso))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dni))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Jefe: ")]), _c('span', {
      staticClass: "name hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_vm._v(_vm._s(o.nombreJefe))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Email Jefe: ")]), _c('span', [_vm._v(_vm._s(o.emailJefe))])])])
  }), 0), (_vm.listaFiltrada.length === 0 || _vm.listaFiltrada.length === -1 || _vm.listaFiltrada.length === undefined) ? _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay empleados que cumplan con los siguientes filtros")])])]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Periodo y Mes")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7e349f8","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Reporte_Lista_Empleados_Vacaciones.vue
// module id = 947
// module chunks = 0